import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'

import PageSection from '../../../../features/components/PageSection'
import ItemsLoading from '../../../../components/Loaders/ItemsLoading'
import TikTokAdPreviewCardItem from './TikTokAdPreviewCardItem'
import SkeletonTikTokAdPreviewCardItem from './TikTokAdPreviewCardItem/Skeleton'

import { adsErrorSelector, adsIsLoadingSelector, adsWasLoadedSelector } from '../../../../modules/selectors/ads'
import { selectedPartnershipSelector } from '../../../../modules/selectors/partnerships'

import useStyles from './styles'

const TikTokAdsPreviewList = ({ adsList, noDataText, ...props }) => {
  const classes = useStyles()

  const selectedPartnership = useSelector(selectedPartnershipSelector)

  const { spend_metrics: showAdditionalMetrics } = selectedPartnership

  // show conversions column if at least one item has positive value
  const showConversionsMetric = useMemo(() => !!adsList.find(ad => ad.conversions), [adsList])

  const skeletonProps = useMemo(
    () => ({
      showAdditionalMetrics,
      showConversionsMetric,
      ...props
    }),
    [showAdditionalMetrics, showConversionsMetric, props]
  )

  return (
    <ItemsLoading
      itemsLength={adsList.length}
      className={classes.cardsList}
      noDataText={noDataText}
      isLoadingSelector={adsIsLoadingSelector}
      wasLoadedSelector={adsWasLoadedSelector}
      errorSelector={adsErrorSelector}
      initialLoadingSkeletonsNumber={5}
      SkeletonComponent={SkeletonTikTokAdPreviewCardItem}
      ContentWrapper={PageSection}
      skeletonProps={skeletonProps}
    >
      {adsList.map(ad => (
        <TikTokAdPreviewCardItem
          key={ad.id}
          ad={ad}
          showConversionsMetric={showConversionsMetric}
          showAdditionalMetrics={showAdditionalMetrics}
          {...props}
        />
      ))}
    </ItemsLoading>
  )
}

TikTokAdsPreviewList.propTypes = {
  adsList: PropTypes.array.isRequired,
  noDataText: PropTypes.string,
  showStatusChip: PropTypes.bool,
  showActionsDropdown: PropTypes.bool,
  showDetails: PropTypes.bool,
  showMetrics: PropTypes.bool,
  showInternalAdActionButtons: PropTypes.bool,
  disapproveInternalAdOpenModalHandler: PropTypes.func
}

export default TikTokAdsPreviewList
